import React from 'react';
import PropTypes from 'prop-types';
import LinkCard from '../../LinkCard/LinkCard';
import { FormattedMessage } from 'react-intl';

const HomepageBigPromise = () => {
  return (
    <section className="homepage-banner">
      <div className="homepage-jumbotron">
        <div className="container">
          <div className="homepage-banner-content">
            <h1>Now is the time to go electric.</h1>
            <p>
              <FormattedMessage
                id="homepage.banner.title"
                defaultMessage="Compare estimated costs, savings, incentives & more."
                description="Compare estimated costs, savings, incentives & more. "
              />
            </p>
          </div>
        </div>
      </div>
      <div className="link-card-container">
        <div className="container">
          <LinkCard type="COMPARE_RATES" />
          <LinkCard type="DISCOVER_INCENTIVES" />
          <LinkCard type="BROWSE_VEHICLES" />
          <LinkCard type="COMPARE_VEHICLES" />
          <LinkCard type="FIND_CHARGING" />
        </div>
      </div>
    </section>
  );
};

export default HomepageBigPromise;

HomepageBigPromise.propTypes = {
  homePageBannerImage: PropTypes.string,
  userLocation: PropTypes.string,
};
